import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react'

interface PageHeaderContextType {
  subtitle: string
  setSubtitle: (subtitle: string) => void
}

const PageHeaderContext = createContext<PageHeaderContextType | undefined>(undefined)

export const PageHeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [subtitle, setSubtitleState] = useState('')
  const setSubtitle = useCallback((value: string) => setSubtitleState(value), [])

  return (
    <PageHeaderContext.Provider value={{ subtitle, setSubtitle }}>
      {children}
    </PageHeaderContext.Provider>
  )
}

const noop = () => {}

export const usePageHeader = (): PageHeaderContextType => {
  const context = useContext(PageHeaderContext)
  return context ?? { subtitle: '', setSubtitle: noop }
}
